import { useQuery } from '@tanstack/react-query'

import { useAuthStore } from '@/stores/authStore'

import { meusAvisosFeriasApi } from '../api/meusAvisosFeriasApi'

export const meusAvisosFeriasKeys = {
  all: ['meus-avisos-ferias'] as const,
}

/**
 * Avisos de férias do colaborador logado. O id do usuário entra na chave só para o cache não
 * vazar entre sessões de pessoas diferentes no mesmo navegador.
 */
export function useMeusAvisosFerias() {
  const colaboradorId = useAuthStore((state) => state.user?.colaboradorId)
  return useQuery({
    queryKey: [...meusAvisosFeriasKeys.all, colaboradorId],
    queryFn: meusAvisosFeriasApi.list,
    enabled: !!colaboradorId,
  })
}
